import {
  STOCK_GET_LIST_STOCK_BEGIN,
  STOCK_GET_LIST_STOCK_SUCCESS,
  STOCK_GET_LIST_STOCK_FAILURE,
  STOCK_GET_LIST_STOCK_DISMISS_ERROR,

} from './constants';
import axios from "axios"
import { CATALOGO_ENDPOINT } from 'common/endpoints'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getListStock(args = {}, requestChange = false) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_GET_LIST_STOCK_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest =  axios.get(CATALOGO_ENDPOINT + args)
      doRequest.then(
        (res) => {
          dispatch({
            type: STOCK_GET_LIST_STOCK_SUCCESS,
            data: res.data,
            requestChange: requestChange
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: STOCK_GET_LIST_STOCK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetListStockError() {
  return {
    type: STOCK_GET_LIST_STOCK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_GET_LIST_STOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getListStockPending: true,
        getListStockError: null,
      };

    case STOCK_GET_LIST_STOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        getListStockPending: false,
        getListStockError: null,
        dataList: action.data,
        mainCarLotId: action.requestChange ? state.mainCarLotId : action.data?.data[0]?.car_lot_id
      };

    case STOCK_GET_LIST_STOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        getListStockPending: false,
        getListStockError: action.data.error,
      };

    case STOCK_GET_LIST_STOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getListStockError: null,
      };

    default:
      return state;
  }
}
